<section class="specs-container" [class.open-enabled]="isCollapsible" [class.open]="isOpen" tabindex="0" (blur)="handleBlur()">
  @if (isCollapsible) {
  <div class="specs-header" (click)="toggleState()">
    <h2>Details</h2>
    <button class="arrow">
      <icon name="carrot_arrow"></icon>
    </button>
  </div>
  }
  <div class="specs-body" [class.expand]="isCollapsible">
    @if (showPrice && (fp.Price || fp.PriceRange)) {
    <div class="price">
      <icon name="price"></icon>From&nbsp;<span class="value-display">{{fp.PriceDisplay}}</span>
    </div>
    }
    <div class="floorplan-details" [ngClass]="fp.Price ? 'details-with-price' : 'details-without-price'">
      @if (fp.FloorCount) {
      <div class="detail">
        <icon name="floor"></icon>
        <span [innerHtml]="fp.FloorCount"></span>
      </div>
      }
      @if (fp.NumberOfBedrooms || fp.NumberOfBedroomsRange) {
      <div class="detail">
        <icon name="bed"></icon>
        <span [innerHtml]="fp.BedCount"></span>
      </div>
      }
      @if (fp.NumberOfFullBaths || fp.NumberOfFullBathsRange) {
      <div class="detail">
        <icon name="full_bath"></icon>
        <span [innerHtml]="fp.BathCount"></span>
      </div>
      }
      @if (fp.NumberOfHalfBaths || fp.NumberOfHalfBathsRange || fp.HalfBathCount) {
      <div class="detail">
        <icon name="half_bath"></icon>
        <span [innerHtml]="fp.HalfBathCount"></span>
      </div>
      }
      @if (fp.NumberOfDens || fp.DenRange) {
      <div class="detail">
        <icon name="den"></icon>
        <span [innerHtml]="fp.DenCount"></span>
      </div>
      }
      @if (fp.NumberOfGarages || fp.GarageNumberRange) {
      <div class="detail">
        <icon name="garage"></icon>
        <span [innerHtml]="fp.GarageCount"></span>
      </div>
      }
      @if (fp.GarageCarSize || fp.GarageCarSizeRange) {
      <div class="detail">
        <icon name="garage"></icon>
        <span [innerHtml]="fp.GarageSizeCount"></span>
      </div>
      }
      @if (fp.BaseTotalSquareFeet || fp.SquareFeetRange) {
      <div class="detail">
        <icon name="sq_ft"></icon>
        <span [innerHtml]="fp.SqFtCount"></span>
      </div>
      }
      @if (fp.OutdoorSquareFeet) {
      <div class="detail">
        <icon name="sq_ft"></icon>{{fp.OutdoorSquareFeet | specsplural:'SpecOutdoorSqFtLabel'}}
      </div>
      }
    </div>
    @if (fp.AllTagNames) {
    <div class="tags">
      <icon name="tag"></icon>{{fp.AllTagNames}}
    </div>
    }
    @if (fp.IsInventoryHome && fp.MoveInDate) {
    <div class="detail">
      <span>Move In Date: </span>{{fp.MoveInDate | date}}
    </div>
    }
  </div>
</section>
